@file:Suppress("TooGenericExceptionThrown")

package com.klantenstop.web.utils

import com.materialkobweb.utils.Logger
import com.varabyte.kobweb.browser.uri.decodeURIComponent
import com.varabyte.kobweb.browser.uri.encodeURIComponent
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.window

fun logoImage(colorMode: ColorMode) = when (colorMode) {
    ColorMode.DARK -> Res.Image.logoDark
    ColorMode.LIGHT -> Res.Image.logo
}

/**
 * Safely encodes a URL for use as a query parameter using base64 encoding.
 * This is more reliable than URL encoding for complex URLs with multiple query parameters.
 * Uses encodeURIComponent to handle non-Latin1 characters (e.g., Dutch special characters like ë or é)
 * before base64 encoding to prevent DOMException.
 */
fun encodeReturnUrl(url: String): String {
    return try {
        val uriEncoded = encodeURIComponent(url)
        window.btoa(uriEncoded)
    } catch (e: Exception) {
        Logger.error("Functions", "Failed to encode return URL: $url", e)
        ""
    }
}

/**
 * Decodes a base64-encoded URL from a query parameter.
 * Uses decodeURIComponent after base64 decoding to properly restore non-Latin1 characters.
 */
fun decodeReturnUrl(encodedUrl: String): String? {
    return try {
        val base64Decoded = window.atob(encodedUrl)
        decodeURIComponent(base64Decoded)
    } catch (e: Exception) {
        Logger.error("Functions", "Failed to decode return URL: $encodedUrl", e)
        null
    }
}

val websiteRegex = Regex("^(https?://)?([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}(/.*)?$")
